/* eslint-disable no-console */

import { register } from 'register-service-worker';
import store from './store';
import i18n from "./i18n";

function addMsgListener(sw) {
  if (sw == null) {
    return;
  }

  sw.addEventListener('message', event => {
    if (event.data && event.data.type === 'RELOAD_WINDOW') {
      window.location.reload();
    }
  });
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}sw.js`,
    {
      ready(/*registration*/) {
        console.log(
          'App is being served from cache by a service worker.\n'
          + 'For more details, visit https://goo.gl/AFskqB',
        );
      },
      registered () {
        console.log('Service worker has been registered.')
      },
      cached() {
        console.log('Content has been cached for offline use.');
      },
      updated(registration) {
        setTimeout(() => {
          store.dispatch('showNotification', {
            color: 'info',
            message: i18n.t('update_available'),
            timeOut: -1,
            showButton: true,
            buttonText: i18n.t('install_update'),
            callback: () => {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
          })
        }, 1000);
        console.log('New content is available; please refresh.');
      },
      offline() {
        console.log('No internet connection found. App is running in offline mode.');
      },
      error(error) {
        console.error('Error during service worker registration:', error);
      },
    });

  if ('serviceWorker' in navigator) {
    addMsgListener(navigator.serviceWorker);
  }
}

